export { default as MarketThriveIcon } from './MarketThriveIcon';
